<template>
  <div>
    <el-form
      :rules="rules"
      :model="formData"
      ref="form"
      class="main-form-scroll"
    >
      <el-form-item :label="$t('task.taskName')" prop="captionSelected">
        <el-input v-model="formData.captionSelected"></el-input>
      </el-form-item>
      <el-form-item :label="$t('task.path')" prop="pathSelected">
        <el-input v-model="formData.pathSelected"></el-input>
      </el-form-item>
      <el-form-item prop="isPacketableChecked">
        <el-checkbox v-model="formData.isPacketableChecked">{{
          $t("task.opportunityPickInPackage")
        }}</el-checkbox>
      </el-form-item>
      <el-form-item :label="$t('task.taskType')" prop="idTypeTaskSelected">
        <el-select v-model="formData.idTypeTaskSelected" filterable>
          <el-option
            v-for="p in getTypeTaskTable"
            :key="p.id"
            :label="p.name"
            :value="p.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('task.comment')" prop="commentSelected">
        <el-input v-model="formData.commentSelected"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="bottom-buttons">
      <div></div>
      <div>
        <el-button class="button-cancel" type="plain" @click="cancelClick">{{
          $t("task.cancel")
        }}</el-button>
        <el-button class="button-confirm" type="success" @click="okClick"
          >OK</el-button
        >
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  data() {
    const validatePath = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("task.enterTaskPath")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    return {
      formData: {
        captionSelected: null,
        pathSelected: null,
        isPacketableChecked: false,
        idTypeTaskSelected: null,
        commentSelected: null,
      },
      rules: {
        captionSelected: [
          {
            required: true,
            message: this.$t("task.enterTaskName"),
            trigger: "blur",
          },
        ],
        pathSelected: [
          { required: true, validator: validatePath, trigger: "blur" },
        ],
        isPacketableChecked: [{ required: false }],
        idTypeTaskSelected: [
          {
            required: true,
            message: this.$t("task.enterTaskType"),
            trigger: "change",
          },
        ],
        commentSelected: [{ required: false }],
      },
    };
  },
  props: {
    type: String,
  },
  methods: {
    populateForm() {
      this.formData.captionSelected = this.getCurInfo.caption;
      this.formData.pathSelected = this.getCurInfo.path;
      this.formData.idTypeTaskSelected = this.getCurInfo.idTypeTask;
      this.formData.isPacketableChecked =
        this.getCurInfo.isPacketable === "0" ? false : true;
      this.formData.commentSelected = this.getCurInfo.comment;
    },
    okClick() {
      for (let index in this.formData) {
        if (
          this.formData[index] != null &&
          typeof this.formData[index] === "string"
        ) {
          this.formData[index] = this.formData[index].trim();
        }
      }
      this.$refs["form"].validate((valid, object) => {
        if (valid) {
          this.$emit("data", this.formData);
        } else {
          this.$message.error(this.$t("errors.notAllRequiredFieldsSelected"));
        }
      });
    },
    cancelClick() {
      this.$emit("close");
    },
  },
  created() {
    if (this.type === "edit") {
      this.populateForm();
    }
  },
  computed: {
    ...mapGetters(["getCurInfo", "getTypeTaskTable"]),
  },
};
</script>


<style scoped>
</style>